import styled from 'styled-components';
import { Card, CardContent, Box } from '@mui/material';
import { colors } from 'spw-theme';
import { Column, Row } from 'spw-shared/globalComponents';
import React from 'react';

export const CustomCard = styled(Card)`
  && {
    margin-top: 16px;
    font-family: roboto;
    background-color: ${colors.white} !important;
    border: 1px solid ${colors.containerBorder};
  }
`;

export const CustomCardContent = styled(CardContent)`
  &&:last-child {
    padding-bottom: 16px;
  }
`;

export const InsightsCardTitle = styled(Row)`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${colors.black};
`;

export const InsightsCardSubTitle = styled(InsightsCardTitle)``;

export const InsightsCardRow = styled(Row)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    margin-top: 5px;
  }
`;

export const InsightsValue = styled(Column)`
  flex: 1;
  align-items: flex-end;
`;

export const InsightsMetric = styled(Column)``;

export const IconRow = styled(Box)`
  && {
    margin: 16px 0px;
    display: flex;

    div.card-icon {
      display: flex;
      align-items: center;
      margin-right: 32px;
    }

    div.value {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
    }
  }
`;

export const ClockIconWrapper = styled(Box)`
  margin-right: 35px;
  height: 40px;
`;

export const PercentageBarRow = styled(Box)`
  && {
    margin: 16px 0px;
    display: flex;

    div.value {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      margin-right: 30px;
    }
  }
`;

export const PercentageBarContainer = styled.div`
  && {
    width: 100%;
    height: 16px;
    background-color: ${colors.offWhite};
    border: none;
  }
`;

export const PercentageBar = styled(({ ...props }) => <div {...props} />)<{
  width: number;
  color: string;
}>`
  && {
    height: 16px;
    width: ${(props) => props.width};
    background-color: ${(props) => props.color};
    border: none;
  }
`;

export const CardSmallText = styled(Box)`
  && {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 32px;
  }
`;

export const CardText = styled.div`
  && {
    p {
      font-size: 14px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      margin: 0px;
    }

    b {
      font-weight: 500;
    }
  }
`;

export const Legend = styled.p`
  margin: 16px 0px 0px 0px;
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
